import React from 'react'
import PropTypes from 'prop-types'

import ShowOnVisible from 'Components/ShowOnVisible'
import NearbyMapIntro from 'Components/Demographics/components/NearbyMapIntro'
// import Demographics from 'Components/Demographics/DemographicsApiContainer'


const MobileDemographicsMap = ({
  listing,
  building,
  handleDemographicMapClick,
}) => (
  <ShowOnVisible>
    <NearbyMapIntro
      listing={listing}
      building={building}
      isMapOnlyView
      handleDemographicMapClick={handleDemographicMapClick}
    />
  </ShowOnVisible>
)


MobileDemographicsMap.propTypes = {
  listing: PropTypes.shape({}),
  building: PropTypes.shape({}),
  handleDemographicMapClick: PropTypes.func,
}

export default MobileDemographicsMap
